import { Button, Dialog, Text } from '@noorden-insurtech/alba-design-system';
import { CircleCheck, CircleX } from 'lucide-react';

interface DecisionConfirmDialogProps {
  open: boolean;
  onOpenChange: (_open: boolean) => void;
  status: null | 'ACCEPT' | 'REJECT';
  requiresInspection?: string;
  isSubmitting: boolean;
  onConfirm: () => void | Promise<void>;
}

export function DecisionConfirmDialog({
  open,
  onOpenChange,
  status,
  requiresInspection,
  isSubmitting,
  onConfirm,
}: DecisionConfirmDialogProps) {
  const isAccept = status === 'ACCEPT';
  const goesToInspection = requiresInspection === 'S';

  return (
    <Dialog.Root
      open={open}
      onOpenChange={(details: { open: boolean }) => onOpenChange(details.open)}
    >
      <Dialog.Portal>
        <Dialog.Backdrop />
        <Dialog.Positioner>
          <Dialog.Content className='w-full max-w-md'>
            <Dialog.Header>
              <Dialog.Title>
                {isAccept ? (
                  <CircleCheck className='size-6' />
                ) : (
                  <CircleX className='size-6' />
                )}
                Confirmar decisão
              </Dialog.Title>
              <Dialog.CloseTrigger asChild>
                <Dialog.CloseButton />
              </Dialog.CloseTrigger>
            </Dialog.Header>
            <Dialog.Body>
              <Text>
                {isAccept
                  ? goesToInspection
                    ? 'Ao confirmar, esta proposta será aceita e encaminhada para o processo de inspeção.'
                    : 'Ao confirmar, esta proposta será aceita e enviada para o processo de emissão da apólice.'
                  : 'Ao confirmar, esta proposta será recusada e a carta de recusa será enviada.'}
              </Text>
              <Text>Esta ação não poderá ser desfeita.</Text>
            </Dialog.Body>
            <Dialog.Footer>
              <Dialog.CloseTrigger asChild>
                <Button variant='ghost' size='md' disabled={isSubmitting}>
                  Cancelar
                </Button>
              </Dialog.CloseTrigger>
              <Button
                variant='primary'
                size='md'
                disabled={isSubmitting}
                loading={isSubmitting}
                onClick={() => void onConfirm()}
              >
                Confirmar {isAccept ? 'Aceitação' : 'Recusa'}
              </Button>
            </Dialog.Footer>
          </Dialog.Content>
        </Dialog.Positioner>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
